import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { CheckCircle2, Phone, ArrowRight } from "lucide-react";
import Seo from "../components/Seo";
import { useSettings } from "../lib/hooks";
import { telLink, track } from "../lib/api";

export default function ConsultationThankYou() {
  const { data: settings } = useSettings();
  const location = useLocation();
  const firstName = location.state?.name;

  useEffect(() => {
    track("consultation_thank_you");
  }, []);

  return (
    <div data-testid="consultation-thank-you-page">
      <Seo
        title="Thank You | NOOR Design & Build"
        description="Thank you — your consultation request has been received."
        path="/request-a-consultation/thank-you"
        noindex
      />
      <section className="bg-graphite text-white blueprint-grid">
        <div className="max-w-[860px] mx-auto px-5 md:px-10 pt-36 md:pt-52 pb-24 md:pb-36 text-center">
          <CheckCircle2 size={44} strokeWidth={1.25} className="text-ember mx-auto" />
          <h1 className="font-display font-light text-4xl sm:text-5xl tracking-tighter mt-8 leading-[1.08]">
            Thank you{firstName ? `, ${firstName}` : ""}.
          </h1>
          <p className="text-white/60 text-base md:text-lg leading-relaxed mt-8 max-w-xl mx-auto">
            Your consultation request has been received — a confirmation email is on its way to you.
            We will get back to you within one working day.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-12">
            <a
              href={telLink(settings)}
              onClick={() => track("phone_click", { location: "thank_you" })}
              data-testid="thank-you-call-button"
              className="inline-flex items-center justify-center gap-2.5 bg-ember hover:bg-emberdark text-white px-8 py-4 text-sm font-semibold tracking-wide transition-colors duration-300"
            >
              <Phone size={15} /> Prefer to talk? Call {settings?.phone_display || "07782 760 279"}
            </a>
            <Link
              to="/projects"
              data-testid="thank-you-projects-link"
              className="group inline-flex items-center justify-center gap-2.5 border border-white/25 hover:border-white text-white px-8 py-4 text-sm font-semibold tracking-wide transition-colors duration-300"
            >
              Browse our projects <ArrowRight size={14} className="transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
